import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { AbstractSvgIconService } from './abstract-svg-icon.service';
import { Result, ToResult } from '@team23/ts-result';
import { Configuration, IconStatus } from '@ui/shared/util-api';

@Injectable({ providedIn: 'root' })
export class SvgIconService extends AbstractSvgIconService {
    private readonly _headers = new HttpHeaders();

    constructor(
        private readonly _httpClient: HttpClient,
        @Inject(Configuration) private readonly _configuration: Configuration,
    ) {
        super();

        // The HTTP get should expect svg content.
        this._headers.set('Accept', 'image/svg+xml');
    }

    /**
     * Fetch an svg icon from the backend server based on the given iconPath.
     *
     * @param iconPath the relative path of the icon on the server
     * @returns an svg icon, wrapped in a {@link Result}
     */
    public getIconSvgByPath$(iconPath: string): Observable<Result<string, IconStatus>> {
        return this._httpClient.get(
            `${ this._configuration.basePath }${ iconPath }`,
            { headers: this._headers, responseType: 'text' },
        )
            .pipe(
                map(svg => ToResult.fromData(svg)),

                /*
                 * Since we are trying to fetching a file and not speaking with the api,
                 * we will not get any predefined errors; so we set a generic error for all failures.
                 */
                catchError(() => of(ToResult.fromErrorKey(IconStatus.GenericError))),
            );
    }
}
